import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-no-data-renderer',
  standalone: true,
  imports: [CommonModule, AssetVersionPipe],
  templateUrl: './no-data-renderer.component.html',
  styleUrl: './no-data-renderer.component.scss'
})

export class NoDataRendererComponent implements ICellRendererAngularComp {
  public message: string = '';
  public class: string = '';

  agInit(params: ICellRendererParams): void {
    this.message = params?.value as string;
    this.class = (params as any)?.class || '';
  }

  refresh(params: ICellRendererParams): boolean {
    this.message = params?.value as string;
    this.class = (params as any)?.class || '';
    return true;
  }
}

